import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home/home";
import './scss/global.scss';
import Building from "./pages/building/building";
import Availability from "./pages/availability/availability";
import Location from './pages/location/location';
import Contact from "./pages/contact/contact";

const App: React.FC = () => {
    const routes = [
      { path: "/", component: Home },     
      { path: "/building", component: Building },     
      { path: "/availability", component: Availability },     
      { path: "/location", component: Location },     
      { path: "/contact", component: Contact },     
    ];

    return (
        <>
            <BrowserRouter>
                <Routes>
                    {routes.map((route, index) => {
                        return (
                            <Route
                                key={index}
                                path={route.path}
                                element={<route.component />}
                            />
                        );
                    })}
                </Routes>                
            </BrowserRouter>
        </>
    );
};

export default App;
